import React from 'react';

export default () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.5 11H6.5C6.22375 11 6 11.2237 6 11.5V12.5C6 12.7763 6.22375 13 6.5 13H17.5C17.7762 13 18 12.7763 18 12.5V11.5C18 11.2237 17.7762 11 17.5 11Z'
      fill='#008ED1'
    />
  </svg>
);
